import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, size } from "lodash";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import CollectionHeaderPartner from "../collection-header-partner/CollectionHeaderPartner";
import {
  SECTION_RESIDENTS_COMPONENTS,
  STD_ERROR_MESSAGE,
} from "../../../utils/constant";
import { getImageUrl } from "../../../utils/utils.js";

import ResidentsEdit from "../residents-edit/ResidentsEdit";

import editIcon from "../../../assets/icon/edit.svg";
import deleteIcon from "../../../assets/icon/delete.svg";
import {
  deleteResidentsbySequencePromise,
  fetchResidents,
} from "../../../services/residents.service.js";

const Residents = (props) => {
  const residentsState = useSelector((state) => state.residentsAd);
  const dispatch = useDispatch();
  const params = useParams();
  const [editItem, setEditItem] = useState([]);

  const residentsData = residentsState?.response?.data;

  function handleAddBtn() {
    props.setCurrentMainComponent((prevState) => {
      return {
        currComponent: SECTION_RESIDENTS_COMPONENTS.add_residents_sections,
        prevComponent: prevState.component,
      };
    });
  }

  function handleSectionDelete(sequence) {
    deleteResidentsbySequencePromise(params.collectionId, sequence)
      .then((res) => {
        dispatch(fetchResidents(params.collectionId));
        toast.success("Deletion successful");
      })
      .catch((err) => {
        toast.error(
          !isEmpty(err?.data?.error_data)
            ? err?.data?.error_data
            : STD_ERROR_MESSAGE
        );
      });
  }

  function handleCancelBtnClick(id) {
    setEditItem((ps) => {
      return ps.filter((item) => item !== id);
    });
  }

  return (
    <main
      style={{ maxWidth: "850px", marginLeft: "auto", marginRight: "auto" }}
    >
      <CollectionHeaderPartner
        title={`Residents(${size(residentsData)})`}
        addPhotosBtn={true}
        addPhotosLabel="Add Residents"
        handleAddPhotosBtn={handleAddBtn}
      />
      <div className="mt-3">
        {!isEmpty(residentsData) ? (
          residentsData.map((residentsSection, index) =>
            editItem.includes(residentsSection.id) ? (
              <ResidentsEdit
                key={residentsSection.id}
                onCancelClick={() => handleCancelBtnClick(residentsSection.id)}
                residentsSection={residentsSection}
              />
            ) : (
              <div
                className="d-flex p-3 mb-3"
                style={{
                  border: "1px solid rgba(41, 41, 41, 0.38)",
                  borderRadius: "8px",
                }}
                key={residentsSection.id}
              >
                <div
                  className="secondary-color-bg"
                  style={{
                    width: "180px",
                    height: "180px",
                    borderRadius: "50%",
                  }}
                >
                  <div className="h-100 position-relative">
                    <img
                      src={getImageUrl(residentsSection?.image?.bucket_path)}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "50%",
                      }}
                    />
                  </div>
                </div>
                <div className="flex-1 ml-3">
                  <div>
                    <div className="mb-1 d-flex justify-content-between">
                      <h3 className="pb18-lh32 high-emphasis-color">
                        {residentsSection.title}
                      </h3>
                      <div>
                        <img
                          style={{
                            width: "1.25rem",
                            height: "1.25rem",
                          }}
                          className="ml-2 pt-cursor"
                          src={editIcon}
                          alt=""
                          onClick={() =>
                            setEditItem((ps) => {
                              return [...ps, residentsSection.id];
                            })
                          }
                        />
                        <img
                          style={{
                            width: "1.25rem",
                            height: "1.25rem",
                          }}
                          className="ml-2 pt-cursor"
                          src={deleteIcon}
                          alt=""
                          onClick={() =>
                            handleSectionDelete(residentsSection.sequence)
                          }
                        />
                      </div>
                    </div>
                    <div>
                      <p className="pr16-lh24">{residentsSection.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            )
          )
        ) : (
          <h2 className="text-center pr20-lh32 high-emphasis-color mt-5">
            You have no sections in this collection
          </h2>
        )}
      </div>
    </main>
  );
};

export default Residents;
